import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

const Slack = () => {
  return(
    <Carousel slide={false}>
      <Carousel.Item>
        <img
          id="bot"
          className="d-block"
          src="./img/communications/bot.png"
          alt="SmartCrib Slack Bot"
        />
        <Carousel.Caption>
          <h3>SmartCrib App on Slack</h3>
          <p>
            We built a Slack app/bot for our project channel to send out warning notifications when any irregularity in the data is detected.
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          id="bot1"
          className="d-block"
          src="./img/communications/bot1.png"
          alt="Message sent by SmartCrib Bot that shows SmartCrib is turned on."
        />
        <Carousel.Caption>
          <h3>SmartCrib Turn On Notification</h3>
          <p>SmartCrib Bot sends an notification when SmartCrib is turned on.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="warning d-block"
          src="./img/communications/breathing.png"
          alt="Warning message sent by SmartCrib Bot about abnormality in respiratory rate detected."
        />
        <Carousel.Caption>
          <h3>Respiratory Irregularity Warning</h3>
          <p>SmartCrib Bot sends a warning message when irregularity in breathing is detected.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="warning d-block"
          src="./img/communications/heart.png"
          alt="Warning message sent by SmartCrib Bot about abnormality in respiratory rate detected."
        />
        <Carousel.Caption>
          <h3>Abnormal Heart Rate Warning</h3>
          <p>Warning message sent by SmartCrib Bot about abnormality in heart rate detected.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="warning d-block"
          src="./img/communications/sound-movement.png"
          alt="Warning message sent by SmartCrib Bot about abnormality in the infant's activity detected."
        />
        <Carousel.Caption>
          <h3>Abnormal Activity Warning</h3>
          <p>Warning message sent by SmartCrib Bot about abnormality in the infant's activity (too many activities).</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default Slack;
